module.exports = __webpack_public_path__ + "8ad0f75103d65b05eb13f3c35773c2db.png";